import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Schedule } from "src/app/shared/interfaces/course-schedule";
import { Guid } from "src/app/shared/types/guid";

export const courseSchedulePrefix = "[Course Schedule List]";

const courseScheduleListActions = {
  request: `${courseSchedulePrefix} Load`,
  requestActiveSuccess: `${courseSchedulePrefix} Load success`,
  requestFail: `${courseSchedulePrefix} Load fail`,
  requestClear: `${courseSchedulePrefix} Clear`,
};

export const courseScheduleListLoad = createAction(
  courseScheduleListActions.request,
  props<{
    CourseId: Guid;
    GroupId: Guid;
  }>(),
);

export const courseScheduleListLoadSuccess = createAction(
  courseScheduleListActions.requestActiveSuccess,
  props<{ schedule: Schedule }>(),
);

export const courseScheduleListFailure = createAction(
  courseScheduleListActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);

export const courseScheduleListClear = createAction(
  courseScheduleListActions.requestClear,
);
